import HttpService from '@/common/services/HttpService'
import type { CustomerDetailsDTOV1, CustomerDTOV4, CustomerFieldConfigV3, CustomerFieldConfigV4 } from '@/common/types/customer'
import type {
  SearchDuplicatesDTOV1,
  SearchDuplicatesParamsDTOV1,
  CustomerWithCustomfieldDTOV1,
  MergedCustomerWithCustomfield,
} from '@/agent/types/customerFederation'

export const getIfCustomerHasDuplicates = (
  customerRef: string | null,
  customerPhones: Array<string>,
  customerEmails: Array<string>,
  nir: string | null,
) => {
  if (!customerRef && !customerPhones.length && !customerEmails.length && !nir) return []

  const customerParams: SearchDuplicatesParamsDTOV1 = {
    customerReference: customerRef || undefined,
    phones: customerPhones.join(',') || undefined,
    emails: customerEmails.join(',') || undefined,
    nir: nir || undefined,
  }

  return HttpService.putData<SearchDuplicatesDTOV1>(
    `/api/v1/customers/search-duplicates`,
    {},
    {
      params: customerParams,
    },
  )
}

export const findDuplicateCustomersById = (customerId: number) => {
  return HttpService.putData<SearchDuplicatesDTOV1>(`/api/v1/customers/${customerId}/search-duplicates`)
}

export const mergeCustomer = (archivedCustomerId: number | null, targetCustomer: MergedCustomerWithCustomfield) => {
  return HttpService.putData<{ id: number }>(`/api/v1/customers/${archivedCustomerId}/merge`, targetCustomer)
}

export const mergeCustomerOnCreate = (
  existingCustomerId: number | null,
  newCustomer: CustomerWithCustomfieldDTOV1,
  targetCustomer: MergedCustomerWithCustomfield,
) => {
  return HttpService.putData<{ id: number }>(`/api/v1/customers/${existingCustomerId}/update-by-merge-on-create`, {
    customerMerge: targetCustomer,
    customer: newCustomer,
  })
}

export const getBulkCustomers = async (ids?: number[], { includes, expands }: CustomerFieldConfigV3 = {}): Promise<CustomerDetailsDTOV1[]> => {
  const params = {
    include: includes?.size ? [...includes].join() : undefined,
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.postData<CustomerDetailsDTOV1[]>(`/api/v1/bulk-customers/fetch`, { ids }, { params })
}

export const getCustomerV4 = async (customerId: number, { includes, expands }: CustomerFieldConfigV4 = {}): Promise<CustomerDTOV4> => {
  const params = {
    include: includes?.size ? [...includes].join() : undefined,
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.getData<CustomerDTOV4>(`/api/v4/customers/${customerId}`, {
    params,
  })
}

export const deleteCustomerDataDeletionDate = async (customerId: number): Promise<void> => {
  return HttpService.deleteData<void>(`/api/v1/customers/${customerId}/data-deletion-date`)
}

export const updateCustomerCompany = async (customerId: number, companyIds: number[]): Promise<void> => {
  return HttpService.patchData(`/api/v3/customers/${customerId}/company`, {
    companyIds,
  })
}

export const unlinkCustomerFromCompany = async (customerId: number): Promise<void> => {
  return HttpService.patchData(`/api/v3/customers/${customerId}/company`, {
    companyIds: [],
  })
}
